import { rupiah } from "@/lib/api";

const STATUS = { AGREES: "Sesuai", DIFFERENCE: "Selisih", NOT_SUPPLIED: "Sumber tidak tersedia", REVIEW_REQUIRED: "Perlu reviu" };
const amount = (v) => (v === null || v === undefined ? "—" : rupiah(Number(v)));

// Month by month to the year, bridged to the trial-balance control where one exists, then the lumpsum
// journals the reference match could not reach. Everything here is a figure or a candidate: a month
// without one side reads "Sumber tidak tersedia", never zero, and no candidate is a match.
export default function MonthlyBridge({ bridge, lumpsum, sourceLabel, sourceKey, prefix }) {
  if (!bridge) return <div className="text-xs text-muted-foreground" data-testid={`${prefix}-bridge-empty`}>Rekonsiliasi GL belum dapat dijalankan; jembatan bulanan belum tersedia.</div>;
  const annual = bridge.annual || {};
  return (
    <div className="space-y-3" data-testid={`${prefix}-bridge`}>
      <table className="w-full audit-table text-xs">
        <thead><tr><th>Bulan</th><th className="text-right">{sourceLabel}</th><th className="text-right">GL</th><th className="text-right">Selisih</th><th>Status</th></tr></thead>
        <tbody>
          {bridge.months.map((m) => (
            <tr key={m.month} data-testid={`${prefix}-bridge-${m.month}`}>
              <td>{m.month}</td><td className="text-right tabular-nums">{amount(m[sourceKey])}</td>
              <td className="text-right tabular-nums">{amount(m.gl)}</td><td className="text-right tabular-nums">{amount(m.difference)}</td>
              <td>{STATUS[m.status] || m.status}</td>
            </tr>))}
          <tr className="font-semibold" data-testid={`${prefix}-bridge-annual`}>
            <td>Tahunan</td><td className="text-right tabular-nums">{amount(annual[sourceKey])}</td>
            <td className="text-right tabular-nums">{amount(annual.gl)}</td><td className="text-right tabular-nums">{amount(annual.difference)}</td>
            <td>{STATUS[annual.status] || annual.status}</td>
          </tr>
        </tbody>
      </table>
      <div className="text-xs" data-testid={`${prefix}-bridge-control`}>
        Kontrol neraca saldo: {annual.control_status === "NOT_SUPPLIED" ? "tidak tersedia untuk domain ini"
          : `${amount(annual.annual_control)} · selisih GL terhadap kontrol ${amount(annual.ledger_vs_control)} (${STATUS[annual.control_status]})`}
      </div>
      <div className="text-xs font-semibold pt-2">Kandidat posting gabungan (lumpsum)</div>
      <p className="text-xs text-muted-foreground">Satu entri GL tanpa referensi faktur yang nilainya sama dengan total item terbuka pada tanggal atau bulan yang sama. Ini kandidat, bukan pencocokan — status item tidak berubah sampai auditor memutuskan.</p>
      {(lumpsum?.candidates || []).length === 0
        ? <div className="text-xs text-muted-foreground" data-testid={`${prefix}-lumpsum-empty`}>Tidak ada kandidat.</div>
        : (
          <table className="w-full audit-table text-xs" data-testid={`${prefix}-lumpsum`}>
            <thead><tr><th>Status</th><th>Lingkup</th><th>Periode</th><th>Entri GL</th><th className="text-right">Item</th><th className="text-right">Nilai</th></tr></thead>
            <tbody>{lumpsum.candidates.map((c, i) => (
              <tr key={i}><td>{c.status === "AMBIGUOUS" ? "Ambigu" : "Kandidat"}</td><td>{c.scope === "DAY" ? "Harian" : "Bulanan"}</td>
                <td>{c.period}</td><td className="break-all">{(c.ledger_references || []).filter(Boolean).join(", ") || c.ledger_ids.join(", ")}</td>
                <td className="text-right tabular-nums">{c.source_count}</td><td className="text-right tabular-nums">{amount(c.amount)}</td></tr>))}
            </tbody>
          </table>)}
    </div>
  );
}
